<template>
  <section class="reset-pwd">
    <div class="reset-content" v-if="!resetSuccess && !resetLinkExpired && resetPwdConfig">
      <reset-pwd-header :sendData="sendData" :clearAllTimer="clearAllTimer" v-bind="resetPwdConfig">
      </reset-pwd-header>

      <!-- <restpwd-form v-bind="resetPwdConfig" :errMessage="errMessage" ref="restpwdForm">
      </restpwd-form> -->
      <ResetPasswordForm ref="restpwdForm" :errMessage="errMessage" :currentStep="currentStep" />

      <div class="resetpwd-btn">
        <!-- <Button class="dpi-button" @click="back">{{ $t('cancel') }}</Button> -->
        <button class="dpi-button dpi-button-primary" @click="handleActive">
          {{ $t(buttonName) }}
        </button>
      </div>
    </div>
    <div v-if="resetSuccess && !resetLinkExpired">
      <message-page :options="successPageOptions" @btnClick="handleBtnConfirm"></message-page>
    </div>
    <div v-if="resetLinkExpired">
      <message-page :options="expiredPageOptions" @btnClick="handleBtnConfirm"></message-page>
    </div>
  </section>
</template>

<script>
  import restpwdForm from '@/components/BaseUi/Form/src';
  import ResetPwdHeader from '@/components/ResetPwdHeader/src';
  import { email, password, verification } from './config';
  import verity from '@/utils/verify';
  import { mapState } from 'vuex';
  import MessagePage from '@/components/MessagePage';
  import i18n from '@/i18n';
  // import axios from 'axios';
  import ResetPasswordForm from '@/components/ResetPasswordForm/index.vue';

  export default {
    components: {
      restpwdForm,
      ResetPwdHeader,
      MessagePage,
      ResetPasswordForm,
    },

    data() {
      return {
        resetPwdConfig: null,
        errMessage: [],
        userKey: '',
        buttonName: '',
        sendData: {},
        clearAllTimer: false,
        resetLinkExpired: false,
        resetSuccess: false,
        successPageOptions: {
          title: 'reset-success-title',
          desc: [{ content: 'reset-success-desc' }, { content: 'reset-success-sub-desc' }],
        },
        expiredPageOptions: {
          title: 'link-expired-title',
          image: 'tip',
          desc: [{ content: 'link-expired-desc' }],
        },
        currentStep: '',
      };
    },
    mounted() {
      const isFromPortal = this.$route?.query?.source === 'portal';
      this.$store.commit('setState', {
        state: 'isFromPortal',
        values: isFromPortal,
      });
      if (isFromPortal) {
        this.resetPwdConfig = password;
        this.buttonName = 'btn-next';
        this.currentStep = 'password';
        this.resetPasswordEmailExpire();
        this.getLangPackage();
      } else {
        this.resetPwdConfig = email;
        this.buttonName = 'btn-send';
        this.currentStep = 'email';
      }
    },
    computed: {
      ...mapState(['isFromPortal']),
    },
    methods: {
      // 按钮事件触发
      handleActive() {
        const { password, confirmPassword, username, verificationCode } =
          this.$refs.restpwdForm.modalValue;
        if (this.currentStep === 'email') {
          this.handleVerity({ username }, verification, 'email');
        } else if (this.currentStep === 'verification') {
          this.handleVerity({ verificationCode }, password, 'verification');
        } else if (this.currentStep === 'password') {
          this.handleVerity({ password, confirmPassword }, 'finish');
        }
      },

      // 验证事件触发
      handleVerity(formData, formConfig, currentStep) {
        verity(formData).then(errMsg => {
          if (errMsg.pass) {
            if (currentStep === 'email') {
              this.handleSendCode(formData, formConfig);
            } else if (currentStep === 'verification') {
              this.handleCheckCode(formData, formConfig);
            } else {
              if (this.isFromPortal) {
                this.handlePortalResetPassword(formData);
              } else {
                this.handleSavaNewPassword(formData);
              }
            }
            this.errMessage = [];
          } else {
            console.log(errMsg);
            this.errMessage = errMsg;
          }
        });
      },

      // 发送校验码
      handleSendCode(data, formConfig) {
        this.$loading.show();
        this.$http.login.sendCode({ email: data.username }).then(
          res => {
            if (res.state === '11') {
              this.userKey = res.key;
              this.resetPwdConfig = formConfig;
              this.currentStep = 'verification';
              this.sendData = data;
              this.buttonName = 'btn-continue';
              this.$loading.hide();
            } else if (res.state === '00') {
              this.errMessage = [{ pass: false, name: 'username', errMessage: res.note }];
              this.$loading.hide();
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },

      // 校验验证码是否正确
      handleCheckCode(data, formConfig) {
        this.$loading.show();
        this.$http.login
          .checkCode({ email: data.username, code: data.verificationCode, key: this.userKey })
          .then(
            res => {
              if (res?.state === '11') {
                this.clearAllTimer = true;
                this.resetPwdConfig = formConfig;
                this.currentStep = 'password';
                this.buttonName = 'btn-next';
                this.$loading.hide();
              } else if (res.state === '00') {
                this.errMessage = [{ pass: false, name: 'verificationCode', errMessage: res.note }];
                this.$loading.hide();
              }
            },
            err => {
              console.error(err);
              this.$loading.hide();
            },
          );
      },

      // 保存新密码
      handleSavaNewPassword(data) {
        this.$loading.show();
        this.$http.login
          .saveNewPassword({ email: data.username, key: this.userKey, password: data.password })
          .then(
            res => {
              if (res.state === '11') {
                this.$loading.hide();
                // 保存密码成功，跳转到首页弹窗login弹窗
                this.$messageModal.show({
                  i18nNeed: true,
                  image: true,
                  title: 'msg-success-status',
                  desc: 'passwordSf',
                  confirmBtn: 'login',
                  nextStep: '/',
                });
              } else if (res.state === '00') {
                this.errMessage = [
                  { pass: false, name: 'password', errMessage: '' },
                  { pass: false, name: 'confirmPassword', errMessage: res.note },
                ];
                this.$loading.hide();
              }
            },
            err => {
              console.error(err);
              this.$loading.hide();
            },
          );
      },

      async getLangPackage() {
        const lang = this.$route?.query?.resetpwd_lang;
        const langMap = {
          en: 'en_US',
          fr: 'fr_CA',
          es: 'es_ES',
          pt: 'pt_PT',
        };
        i18n.locale = langMap[lang];
        /* const langPackServer = {
          'https://dp-oss.dragonpass.com/': 'dp-oss',
          'https://img.dragonpass.com.cn/': 'img',
        };
        const currentLangPath = this.$store.state.globalLangList.find(item => {
          return item.param === langMap[lang];
        }).path;
        let params = null;
        Object.keys(langPackServer).forEach(_ => {
          if (currentLangPath.includes(_)) {
            params = {
              server: _,
              tag: langPackServer[_],
            };
          }
        });
        const currentLang = currentLangPath.split(params.server)[1];
        try {
          const currentLangRes = await axios.get(`/packServer/${params.tag}/${currentLang}`);
          if (currentLangRes) {
            i18n.mergeLocaleMessage(langMap[lang], currentLangRes.data.content);
          }
        } catch (err) {
          console.error(err);
        } */
      },

      // 判断链接是否过期
      resetPasswordEmailExpire() {
        const { token, region } = this.$route.query || {};
        this.$http.login.resetPasswordEmailExpire({ token, region }).then(
          res => {
            if ((res.state === '11' && !res.data) || res.state === '00') {
              // res.data为true表示在有效期内
              this.resetSuccess = false;
              this.resetLinkExpired = true;
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },

      // 保存portal用户的新密码
      handlePortalResetPassword(data) {
        const { token, resetpwd_lang: lang, region } = this.$route.query || {};
        this.$http.login.resetPortalPassword({ password: data.password, token, lang, region }).then(
          res => {
            if (res.state === '11') {
              this.$loading.hide();
              this.resetSuccess = true;
            } else if (res.state === '00') {
              this.errMessage = [
                { pass: false, name: 'password', errMessage: '' },
                { pass: false, name: 'confirmPassword', errMessage: res.note },
              ];
              this.$loading.hide();
            }
          },
          err => {
            console.error(err);
            this.$loading.hide();
          },
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
  @import './mobile';
</style>
